<button [disabled]="disabled" [ngClass]="[type, class]" [attr.aria-label]="label" [addAaTags]="label" (keyup.enter)="emitEnter($event)">
  @if (iconImg) {
    <img [addAaTags]="iconAlt" [src]="iconImg">
  }
  {{label}}
</button>
